import React from "react";
import styles from "./viewpensions.module.scss";
import HighlightAltIcon from "@mui/icons-material/HighlightAlt";
import { PensionApplicant } from "../../types/Pension";
import { useHistory } from "react-router";
import Avatar from "../../assets/avatar.jpeg"

const PensionCard = ({ applicant }: { applicant: PensionApplicant }) => {
  const history = useHistory();
  const reduceNameLength = (name: string) => {
    return name.slice(0, 14) + (name.length > 14 ? "..." : "");
  };
  const reduceEmailLength = (name: string) => {
    return name.slice(0, 26) + (name.length > 26 ? "..." : "");
  };
  const imgUrl =
    applicant && applicant.user && applicant.user.imageUrl
      ? applicant.user.imageUrl
      : Avatar;
  const goToApplicant = (id: string) => {
    history.push(`/viewpensions/${id}`);
  };

  return (
    <div
      className={styles.containercard}
      role="button"
      onClick={() => goToApplicant(applicant.id.toString())}
      title={applicant && applicant.attendedTo === true ? 'Treated' : 'Pending'}
    >
       {applicant && applicant.attendedTo === true ? (
        <div className={styles["indicator-treated"]}></div>
      ) : (
        <div className={styles["indicator-pending"]}></div>
      )}
      
      <div className={styles["card-avatar"]}>
        {imgUrl !== undefined && <img src={imgUrl} alt="applicant image" />}
      </div>

      <span className={styles["card-title"]}>
        {reduceNameLength(
          `${applicant && applicant.firstName} ${
            applicant && applicant.lastName
          }`
        )}
      </span>

      <span className={styles["card-subtitle"]}>
        {reduceEmailLength(applicant && applicant.email)}
      </span>
      <span className={styles["card-subtitle"]}>
        {applicant && applicant.phoneNumber}
      </span>

      <div className={styles.cardpointer}>
        <HighlightAltIcon />
      </div>
    </div>
  );
};

export default PensionCard;
